import Layout from "@/components/feature/Layout";
import VideoCard from "@/components/feature/VideoCard";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { getHotVideos, getLatestVideos } from "@/utils/video";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HotRanking from "./components/HotRanking";

const INTRO_POINTS = [
  {
    icon: "ri-stack-line",
    title: "海量资源聚合",
    text: "汇聚电影、电视剧、综艺等多类别高清视频资源，一站浏览，无需东奔西走。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维度筛选",
    text: "按地区、年份、热度、评分灵活筛选与排序，快速锁定你想看的内容。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    text: "紧跟热点持续收录新作，最新上传与热门榜单实时同步，追剧不掉队。",
  },
];

export default function Home() {
  useDocumentMeta(
    "污视频-热门视频资源聚合平台",
    "污视频聚合丰富的视频资源，涵盖电影、电视剧、综艺等多个类别，满足用户多样化的观看需求，是您的视频娱乐平台首选。",
  );

  const heroVideos = getHotVideos(5);
  const latestVideos = getLatestVideos(10);
  const hotVideos = getHotVideos(10);

  return (
    <Layout>
      <HeroCarousel videos={heroVideos} />

      <div className="w-full py-12 md:py-16">
        <CategoryEntries />
      </div>

      <section className="w-full px-4 md:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
          <div className="w-full lg:flex-1">
            <div className="mb-6 flex items-end justify-between">
              <div>
                <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  <i className="ri-time-line text-accent-500"></i>
                  最新视频
                </h2>
                <p className="mt-1 text-sm text-foreground-500">
                  按更新时间倒序，第一时间获取新鲜资源
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 md:gap-4 sm:grid-cols-3">
              {latestVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[360px] shrink-0">
            <HotRanking videos={hotVideos} />
          </div>
        </div>
      </section>

      <section className="mt-12 w-full px-4 md:mt-16 md:px-8">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:p-10">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                关于平台
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                污视频 · 你的影视发现入口
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                污视频是一款以内容聚合为核心的视频娱乐平台。我们不做播放与下载，而是把散落在各处的热门影视综艺资源整理成清晰的信息卡片，让你用最少的时间找到最想看的作品。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href="#top"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-compass-3-line"></i>
                  开始探索
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-1">
              {INTRO_POINTS.map((point) => (
                <div
                  key={point.title}
                  className="flex gap-3 rounded-lg border border-background-100 bg-background-100/60 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${point.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950">
                      {point.title}
                    </h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-500 md:text-sm">
                      {point.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}